const ReportsView = () =>
	import(
		/* webpackChunkName: "reportsview"*/ "@/views/ReportsView/index.vue"
	);
const ReportsHospitalsView = () =>
	import(
		/* webpackChunkName: "reportshospitalsview"*/ "@/views/ReportsView/HospitalsView.vue"
	);
const ReportsHospitalUsersView = () =>
	import(
		/* webpackChunkName: "reportshospitalusersview"*/ "@/views/ReportsView/HospitalUsersView.vue"
	);
const ReportsHospitalMarketView = () =>
	import(
		/* webpackChunkName: "reportshospitalmarketview"*/ "@/views/ReportsView/HospitalMarketView.vue"
	);
const ReportsListingsView = () =>
	import(
		/* webpackChunkName: "reportslistingsview"*/ "@/views/ReportsView/ListingsView.vue"
	);
const ReportsOrganisationUserView = () =>
	import(
		/* webpackChunkName: "reportsorganisationuserview"*/ "@/views/ReportsView/OrganisationUserView.vue"
	);
const ReportsGlobalView = () =>
	import(
		/* webpackChunkName: "reportsglobalview"*/ "@/views/ReportsView/GlobalView.vue"
	);

export default [
	{
		path: "reports/",
		name: "ReportsView",
		component: ReportsView,
		meta: {
			title: "DailyAdmin - Reports"
		}
	},
	{
		path: "reports/hospitals",
		name: "ReportsHospitalsView",
		component: ReportsHospitalsView,
		meta: {
			title: "DailyAdmin - Reports hospital"
		}
	},
	{
		path: "reports/hospital-users",
		name: "ReportsHospitalUsersView",
		component: ReportsHospitalUsersView,
		meta: {
			title: "DailyAdmin - Reports hospital user"
		}
	},
	{
		path: "reports/hospital-market",
		name: "ReportsHospitalMarketView",
		component: ReportsHospitalMarketView,
		meta: {
			title: "DailyAdmin - Reports hospital market"
		}
	},
	{
		path: "reports/listings",
		name: "ReportsListingsView",
		component: ReportsListingsView,
		meta: {
			title: "DailyAdmin - Reports listings"
		}
	},
	{
		path: "reports/organisation-user",
		name: "ReportsOrganisationUserView",
		component: ReportsOrganisationUserView,
		meta: {
			title: "DailyAdmin - Reports organisation user"
		}
	},
	{
		path: "reports/global",
		name: "ReportsGlobalView",
		component: ReportsGlobalView,
		meta: {
			title: "DailyAdmin - Reports global"
		}
	}
];
